import { render } from "./ViewExtraction.vue?vue&type=template&id=003e19aa&scoped=true"
import script from "./ViewExtraction.vue?vue&type=script&lang=js"
export * from "./ViewExtraction.vue?vue&type=script&lang=js"

import "./ViewExtraction.vue?vue&type=style&index=0&id=003e19aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003e19aa"]])

export default __exports__